import { useCartStore } from '@/store'
import { useQuery } from '@tanstack/react-query'

interface UseRefetchCartOptions {
  /**
   * Thời gian data được coi là fresh (ms)
   * @default 1000 * 60 * 5 (5 phút)
   */
  staleTime?: number

  /**
   * Có tự động refetch khi window focus không
   * @default true
   */
  refetchOnWindowFocus?: boolean

  /**
   * Có enable query không
   * @default true
   */
  enabled?: boolean

  /**
   * Interval để tự động refetch (ms)
   * @default undefined (không tự động refetch)
   */
  refetchInterval?: number
}

export const useRefetchCart = (options?: UseRefetchCartOptions) => {
  const { refetchCart } = useCartStore()

  const {
    staleTime = 1000 * 60 * 5, // 5 phút
    refetchOnWindowFocus = true,
    enabled = true,
    refetchInterval,
  } = options || {}

  const query = useQuery({
    queryKey: ['REFETCH_CART_ON_FOCUS'],
    queryFn: async () => {
      return await refetchCart()
    },
    staleTime,
    refetchOnWindowFocus,
    enabled,
    refetchInterval,
    // Không retry khi lỗi
    retry: false,
    // Không refetch khi mount nếu data đã fresh
    refetchOnMount: false,
  })

  return {
    isLoading: query.isLoading || query.isFetching,

    refetch: query.refetch,

    error: query.error,

    isSuccess: query.isSuccess,

    data: query.data,
  }
}
